import { useEffect, useRef, useCallback } from 'react';
import { inactivityTimeoutMs } from '../utils/inactivityPolicy';

const INACTIVITY_TIMEOUT = inactivityTimeoutMs(
  process.env.REACT_APP_LOCAL_DEMO_SESSION,
  window.location.origin,
  process.env.REACT_APP_API_URL
);

export function useInactivityTimeout(onTimeout) {
  const timerRef = useRef(null);

  const resetTimer = useCallback(() => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      onTimeout?.();
    }, INACTIVITY_TIMEOUT);
  }, [onTimeout]);

  useEffect(() => {
    const events = ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart'];

    const handleActivity = () => resetTimer();

    events.forEach((event) => window.addEventListener(event, handleActivity));
    resetTimer();

    // Also handle tab visibility
    const handleVisibility = () => {
      if (document.visibilityState === 'visible') {
        resetTimer();
      }
    };
    document.addEventListener('visibilitychange', handleVisibility);

    return () => {
      events.forEach((event) => window.removeEventListener(event, handleActivity));
      document.removeEventListener('visibilitychange', handleVisibility);
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [resetTimer]);
}
